import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, ChargeDto, ChargeReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import ChargeInline, { ChargeInlineProps } from "./ChargeInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: ChargeDto | ChargeReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<ChargeInlineProps>;
}

export default function ChargeLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.ChargeRead]}
      to={ROUTE_PATH.CHARGE_VIEW(entity?.id || entityId || "")}
      content={
        <ChargeInline entity={entity} entityId={entityId} {...inlineProps} withTooltip={false} />
      }
      {...otherProps}
    />
  );
}
